<template>

  <PasswordRecoveryFinish v-if="success"></PasswordRecoveryFinish>
  <PasswordRecoveryForm v-else @success="handleSuccess" @error="handleError"></PasswordRecoveryForm>
  <toast v-if="toast.title && toast.message" :toast="toast"></toast>
</template>

<script>

import PasswordRecoveryForm from "./PasswordRecoveryForm.vue";
import PasswordRecoveryFinish from "./PasswordRecoveryFinish.vue";
import Toast from "../../alert/Toast.vue";

export default {
  name: "PasswordRecovery",
  components: {Toast, PasswordRecoveryFinish, PasswordRecoveryForm},
  data: function () {
    return {
      success: false,
      toast: {
        title: null,
        message: null,
        type: null,
      },
    };
  },
  methods: {
    showErrorToast(title, message) {
      this.toast.type = 'error';
      this.toast.message = message;
      this.toast.title = title;

      // АДСКИЙ КОСТЫЛЬ
      setTimeout(() => {
        this.toast.type = null;
        this.toast.message = null;
        this.toast.title = null;
      }, 3500);
    },
    handleSuccess(response) {
      this.success = response.status === 200;
    },
    handleError(error) {
      this.showErrorToast("Восстановление пароля", error.response.data.message);
    },
  },
}
</script>